// extracted by mini-css-extract-plugin
module.exports = {"tableSearch":"table_tableSearch__3PrBd","searchInput":"table_searchInput__3_Y-M","loading":"table_loading__2vS6d"};